export default __webpack_public_path__ + "static/media/loaderMob.0facd067.mp4";